<template>
  <TagSelector
    :multiple="multiple"
    :items="contentSections"
    :value="value"
    @input="$emit('input', $event)"
  />
</template>

<script>
export default {
  props: {
    value: [String, Number, Array],
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      contentSections: [],
    };
  },
  created() {
    this.setContentSections();
  },
  methods: {
    async setContentSections() {
      const { data } = await this.$api.ContentSection.lite();
      this.contentSections = data;
    },
  },
};
</script>

<style></style>
